import { IAgencyCouponData, IAgencyRewardData } from './UserContextModels';

export async function GetAgencies(): Promise<any[]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetAgentAgencies`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}

export async function GetApplicationAccess(): Promise<string[]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetApplicationAccess`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}

export async function GetSecurityGroups(): Promise<string[]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetSecurityGroups`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}

export async function GetUserGroups(): Promise<string[]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetUserGroups`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}

export async function GetMarketingInitiatives(): Promise<any[]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetAgentMarketingInitiatives`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}
export async function GetAgencyRewards(): Promise<IAgencyRewardData[]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetAgencyRewards`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}
export async function GetProducerPerformance(): Promise<IProducerPerformance | undefined> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetProducerPerformance`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return undefined;
}
export async function GetAgencyCoupons(): Promise<IAgencyCouponData[]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetAgencyCoupons`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}
